module.exports = __webpack_public_path__ + "static/media/supercharger-med.2a61d355.svg";